import React from 'react';
import { Navigate } from 'react-router-dom';
import { catalogHubPath } from './catalogRegistry';

const ChangeRequesterAreasPage: React.FC = () => (
  <Navigate to={catalogHubPath('requester-areas')} replace />
);

export default ChangeRequesterAreasPage;
